import Image from 'next/image'

export const CartSavingsItem = ({
  description,
  amount,
}: {
  description: string
  amount: string
}) => (
  <div className="flex items-center justify-between">
    <span className="text-sm">{description}</span>
    <div className="flex items-center">
      <Image height={14} width={14} alt="Discount" src="/icons/subtract.svg" />
      <span className="ml-1 text-primary"> - {amount}</span>
    </div>
  </div>
)
